import React from 'react';
import { IconArrowLeft, IconArrowRight } from '@pentabd/icons';
import { Button } from '../button';

import useMediaQuery, { SCREEN_SIZES } from '../../hooks/useMediaQuery';
import DesktopView from './DesktopView';
import MobileView from './MobileView';

export interface PaginationProps {
  totalPage?: number;
  onClick?: (activePage: number) => void;
  activePage?: number;
  previousLabel?: string;
  nextLabel?: string;
  language?: 'bn' | 'en';
}

const Pagination = ({
  totalPage,
  onClick,
  activePage,
  previousLabel,
  nextLabel,
  language = 'en',
}: PaginationProps) => {
  const isMobile = useMediaQuery(`(max-width: ${SCREEN_SIZES.MD})`);

  const previousButton =
    !isMobile && previousLabel
      ? previousLabel
      : language === 'bn'
      ? 'পূর্ববর্তী'
      : 'Previous';

  const nextButton =
    !isMobile && nextLabel ? nextLabel : language === 'bn' ? 'পরবর্তী' : 'Next';

  const nextClickHandler = () => {
    const nextPage = activePage < totalPage ? activePage + 1 : 1;
    onClick(nextPage);
  };

  const previousClickHandler = () => {
    const prevPage = activePage - 1 >= 1 ? activePage - 1 : 1;
    onClick(prevPage);
  };

  const onClickPage = (pageNumber: number) => {
    onClick(pageNumber);
  };

  return (
    <div className="d-flex justify-content-between align-items-center gap-5">
      <Button
        className="d-flex justify-content-center align-items-center bg-transparent border shadow-xs"
        size="xs"
        type="light"
        onClick={previousClickHandler}
        disabled={activePage === 1}
      >
        <IconArrowLeft size="20" />
        {previousButton}
      </Button>

      {isMobile ? (
        <MobileView
          totalPage={totalPage}
          activePage={activePage}
          language={language}
        />
      ) : (
        <DesktopView
          totalPage={totalPage}
          activePage={activePage}
          language={language}
          onClickPage={onClickPage}
        />
      )}

      <Button
        className="d-flex justify-content-center align-items-center bg-transparent border shadow-xs"
        size="xs"
        type="light"
        onClick={nextClickHandler}
        disabled={activePage === totalPage}
      >
        {nextButton}
        <IconArrowRight size="20" />
      </Button>
    </div>
  );
};

export default Pagination;
